import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { ITheaterScreenNode } from '~/types/my-theater';
import ScreenNodeStatus from './ScreenNodeStatus.vue';
import ReferMyTheaterButton from './ReferMyTheaterButton.vue';
import ScreenNodeUptime from './ScreenNodeUptime.vue';
import ScreenNodeRewards from './ScreenNodeRewards.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScreenNode',
  props: {
    node: null,
    dailyRewards: null,
    totalRewards: null
  },
  setup(__props: any) {

const props = __props as {
  node: ITheaterScreenNode;
  dailyRewards?: number;
  totalRewards?: number;
};



const galaLogo = require('@/assets/logos/film-logo.svg');

const truncatedId = computed(() => {
  const nodeId = props.node.nodeId;
  if (!nodeId || nodeId.length <= 10) return nodeId;

  return `${nodeId.slice(0, 6)}...${nodeId.substr(
    nodeId.length - 4,
    nodeId.length,
  )}`;
});

return { __sfc: true,props, galaLogo, truncatedId, ScreenNodeStatus, ReferMyTheaterButton, ScreenNodeUptime, ScreenNodeRewards }
}

})